var map = {
	"./Montserrat-Bold.ttf": 3520,
	"./Montserrat-Medium.ttf": 3521,
	"./Montserrat-Regular.ttf": 3522,
	"./Roboto-Bold.ttf": 3523,
	"./Roboto-Medium.ttf": 3524,
	"./Roboto-Regular.ttf": 3525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3519;